
import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollAnimation();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      ref={ref}
      className={`py-16 sm:py-20 md:py-32 lg:py-40 bg-neutral-50 transition-all duration-1000 min-h-screen flex items-center ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/2e2c7ba7575097a0089f37397be77fd1.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-neutral-900/80 via-neutral-900/50 to-transparent"></div>
      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="w-full text-center lg:text-left max-w-4xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-white tracking-tight mb-4 sm:mb-6 leading-tight">
            {t('hero.title')}
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-neutral-200 mb-6 sm:mb-8 lg:mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start max-w-lg mx-auto lg:mx-0">
            <Button 
              size="lg"
              onClick={() => scrollToSection('about')}
              className="w-full sm:w-auto whitespace-nowrap text-sm sm:text-base"
            >
              {t('hero.knowUs')}
            </Button>
            <Button 
              variant="secondary" 
              size="lg"
              onClick={() => scrollToSection('sermons')}
              className="w-full sm:w-auto whitespace-nowrap text-sm sm:text-base"
            >
              {t('hero.watchSermons')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
